import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';

@Component({
    selector: 'bs-betslip-display-mode-toggle',
    templateUrl: './betslip-display-mode-toggle.component.html',
    styleUrls: ['./betslip-display-mode-toggle.component.scss'],
    standalone: false,
})
export class BetslipDisplayModeToggleComponent {
    @Output() setDisplayMode = new EventEmitter<BetslipDisplayMode>();
    @Input() displayMode: BetslipDisplayMode;

    Linear = BetslipDisplayMode.Linear;
    Tabbed = BetslipDisplayMode.Tabbed;
}
